import { FC } from 'react'

import { ISvgClass } from '../interface'

const OnlypayLogoCompleteIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="130"
      height="55.693"
      viewBox="0 0 130 55.693"
      {...props}
    >
      <path
        id="logo"
        d="M240.35,440.38a27.735,27.735,0,0,1,0-39.38,28.112,28.112,0,0,1,39.6,0,27.733,27.733,0,0,1,0,39.38,28.112,28.112,0,0,1-39.6,0Zm1.821-37.568a25.185,25.185,0,0,0,0,35.756,25.529,25.529,0,0,0,35.958,0,25.187,25.187,0,0,0,0-35.756,25.529,25.529,0,0,0-35.958,0Zm100.456,29.577v-3.735l-3.658-5.9h2.425l2.312,3.95,2.313-3.95h2.439l-3.673,5.9v3.735Zm-16.3,0-.813-1.7h-3.77l-.785,1.7H318.7l4.89-9.788h.085l4.9,9.788Zm-3.925-3.147h2.467c-.463-1-.912-2.021-1.219-2.865C323.353,427.046,322.821,428.331,322.4,429.241Zm-22.16,3.147v-9.64h3.279c2.327,0,3.882,1.1,3.882,3.173s-1.555,3.174-3.882,3.174H302.4v3.293Zm2.159-5.035h1.233c.938,0,1.583-.468,1.583-1.432s-.673-1.446-1.64-1.446H302.4Zm-63.973-6.663c0-6.2,4.983-11.2,11.813-11.2,6.8,0,11.813,4.97,11.813,11.2,0,6.287-4.982,11.2-11.813,11.2S238.427,426.977,238.427,420.69Zm4.857,0a6.956,6.956,0,1,0,6.955-6.976A6.816,6.816,0,0,0,243.284,420.69Zm24.808,10.961h-4.648v-17.9h-1.655v-4.19h6.485v17.9h1.654v4.191Zm1.991-7.548v-3.987h2.69c2.151,0,3.628-1.074,3.628-3.283s-1.542-3.314-3.757-3.314h-2.562v-3.957h2.434c5.331,0,8.894,2.515,8.894,7.271s-3.563,7.27-8.894,7.27Zm57.894-5.149-6.265-6.495-.323-.335v6.67h-1.345v-9.8h.013l6.266,6.494.322.334v-6.668h1.345v9.8Zm-29.139-4.982a5.175,5.175,0,1,1,5.172,4.982A5.013,5.013,0,0,1,298.838,413.973Zm1.36,0a3.805,3.805,0,1,0,3.812-3.788A3.7,3.7,0,0,0,300.2,413.973Zm56.96,4.822v-3.831l-3.644-5.811h1.5l2.817,4.58,2.817-4.58h1.5l-3.645,5.811v3.831Zm-17.533,0v-9.642h1.345v8.556h4.344v1.086Z"
        transform="translate(-232.148 -392.844)"
        fill="inherit"
      />
    </svg>
  )
}

export default OnlypayLogoCompleteIcon
